import { render, staticRenderFns } from "./adjustReportDialog.vue?vue&type=template&id=20c9e08c&scoped=true"
import script from "./adjustReportDialog.vue?vue&type=script&lang=js"
export * from "./adjustReportDialog.vue?vue&type=script&lang=js"
import style0 from "./adjustReportDialog.vue?vue&type=style&index=0&id=20c9e08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9e08c",
  null
  
)

export default component.exports